(() => {
  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Scroll reveal engine
     --------------------------------------------------------------- */
  function initReveal() {
    document.documentElement.classList.add('js-reveal-ready');

    const targets = document.querySelectorAll('.reveal, .reveal-scale, .reveal-stagger');
    if (!targets.length) return;

    if (prefersReducedMotion()) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  }

  /* ---------------------------------------------------------------
     Header: solid-on-scroll, hide-on-scroll-down / reveal-on-scroll-up
     --------------------------------------------------------------- */
  function initHeader() {
    const header = document.getElementById('SiteHeader');
    if (!header) return;

    const toggle = document.getElementById('MobileMenuToggle');
    const mobileNav = document.getElementById('MobileNav');
    const mobileMenuClose = document.getElementById('MobileMenuClose');
    const mobileNavToggles = mobileNav
      ? mobileNav.querySelectorAll('.site-header__mobile-nav-toggle')
      : [];
    let backdrop = document.querySelector('[data-header-backdrop]');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'site-header__backdrop';
      backdrop.setAttribute('data-header-backdrop', '');
      header.insertAdjacentElement('afterend', backdrop);
    }

    let lastScrollY = window.scrollY;
    let ticking = false;
    const hideThreshold = 120;

    const onScroll = () => {
      const currentScrollY = window.scrollY;

      header.classList.toggle('scrolled', currentScrollY > 20);

      const navOpen =
  document.body.classList.contains('nav-open') ||
  document.documentElement.classList.contains('nav-open');
      if (!navOpen) {
        if (currentScrollY <= hideThreshold) {
          header.classList.remove('site-header--hidden');
        } else if (currentScrollY > lastScrollY) {
          header.classList.add('site-header--hidden');
        } else if (currentScrollY < lastScrollY) {
          header.classList.remove('site-header--hidden');
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
    onScroll();

    function collapseMobileMegaMenus() {
      mobileNavToggles.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.remove('is-expanded');
      });
    }

function openNav() {
  toggle.setAttribute('aria-expanded', 'true');
  mobileNav.classList.add('is-open');
  mobileNav.setAttribute('aria-hidden', 'false');
  backdrop.classList.add('is-open');

  document.body.classList.add('nav-open');
  document.documentElement.classList.add('nav-open');
}

function closeNav() {
  toggle.setAttribute('aria-expanded', 'false');
  mobileNav.classList.remove('is-open');
  mobileNav.setAttribute('aria-hidden', 'true');
  backdrop.classList.remove('is-open');

  document.body.classList.remove('nav-open');
  document.documentElement.classList.remove('nav-open');

  collapseMobileMegaMenus();
}

    if (toggle && mobileNav) {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeNav();
        } else {
          openNav();
        }
      });

      backdrop.addEventListener('click', closeNav);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && document.body.classList.contains('nav-open')) {
          closeNav();
          toggle.focus();
        }
      });

      mobileNav.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeNav);
      });
    }

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', closeNav);
    }

    mobileNavToggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(btn.getAttribute('aria-controls'));

        collapseMobileMegaMenus();

        if (!isExpanded && panel) {
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-expanded');
        }
      });
    });
  }

  /* ---------------------------------------------------------------
     Large-desktop-only subtle parallax for large bleed images.
     Disabled on touch devices, smaller viewports, and reduced motion.
     --------------------------------------------------------------- */
  function initParallax() {
    if (prefersReducedMotion()) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const elements = Array.from(document.querySelectorAll('[data-parallax]'));
    if (!elements.length) return;

    const mq = window.matchMedia('(min-width: 1600px)');
    let active = mq.matches;
    let ticking = false;

    const maxOffset = 28;

    const apply = () => {
      if (!active) return;
      elements.forEach((el) => {
        const rect = el.parentElement.getBoundingClientRect();
        const viewportCenter = window.innerHeight / 2;
        const elementCenter = rect.top + rect.height / 2;
        let distance = (elementCenter - viewportCenter) * 0.04;
        distance = Math.max(-maxOffset, Math.min(maxOffset, distance));
        el.style.transform = `translateY(${distance}px)`;
      });
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(apply);
        ticking = true;
      }
    };

    const enable = () => {
      active = mq.matches;
      if (active) {
        window.addEventListener('scroll', onScroll, { passive: true });
        apply();
      } else {
        window.removeEventListener('scroll', onScroll);
        elements.forEach((el) => {
          el.style.transform = '';
        });
      }
    };

    mq.addEventListener ? mq.addEventListener('change', enable) : mq.addListener(enable);
    enable();
  }

  /* ---------------------------------------------------------------
     Product gallery: keep the bar-style pagination in sync with the
     active slide (mirrors the "1 / N" counter it replaced).
     --------------------------------------------------------------- */
  function initProductGalleryPagination() {
    document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((slider) => {
      const bars = slider.querySelectorAll('.pdp-pagination-bar');
      if (!bars.length) return;

      slider.addEventListener('slideChanged', (event) => {
        const activeIndex = event.detail.currentPage - 1;
        bars.forEach((bar, index) => {
          bar.classList.toggle('is-active', index === activeIndex);
        });
      });
    });
  }

  function init() {
    initReveal();
    initHeader();
    initParallax();
    initProductGalleryPagination();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initReveal();
    });
  }
})();
